import { customQuery } from 'config/reactQuery/reactQuery';
import { useMutation } from 'react-query';
import {
  useQueryClient,
  guestBookingQueryKey,
  guestBookingsQueryKeys,
  guestPaymentDueQueryKey,
  guestBookingsInfiniteQueryKeys,
} from '@alluradirect/react';

export interface StripePaymentValues {
  endpoint: string;
  data: {
    stripe_credit_card_brand: string;
    stripe_credit_card_country: string | null;
    stripe_credit_card_exp_month: number;
    stripe_credit_card_exp_year: number;
    stripe_credit_card_last4: string;
    stripe_credit_card_token: string;
    stripe_credit_card: string;
    cardholder_name: string | null;
  };
  additionalSendData?: any;
}

export const useStripePaymentMutation = () => {
  const queryClient = useQueryClient();

  return useMutation<any, any, StripePaymentValues>(
    (values: StripePaymentValues) => {
      const additionalData = values.additionalSendData ?? {};

      return customQuery(values.endpoint, {
        values: { ...values.data, ...additionalData },
        method: 'POST',
        shouldAcceptFalseSuccess: true,
      });
    },
    {
      onSuccess: async (data) => {
        if (data?.SUCCESS) {
          await queryClient.invalidateQueries({ queryKey: guestBookingQueryKey.all });
          await queryClient.invalidateQueries({ queryKey: guestBookingsQueryKeys.all });
          await queryClient.invalidateQueries({ queryKey: guestPaymentDueQueryKey.all });
          await queryClient.invalidateQueries({ queryKey: guestBookingsInfiniteQueryKeys.all });
          await queryClient.invalidateQueries({ queryKey: ['guestAlerts'] });
        }
      },
    }
  );
};
